import _, { cloneDeep } from 'lodash'
import React, { useState } from 'react'
import { Button, FormGroup, Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useServiceContext } from '~/root'
import Modal from '../Modal'
import { Field, Formik, FormikHelpers } from 'formik'
import Validation from '~/lib/Validation'
import { ErrorMessageStyled } from '../ErrorMessage'
import { FsiType } from '~/constants/fsi'
import { toast } from '~/services/toast'
import { changeRequestTypesService } from '~/services/api'

interface SaveAsCRTypeModalProps {
  fsi?: {
    id?: string | number
    type?: string
    name?: string
  }
  onClose?: () => void
}

interface FormValues {
  name: string
  description: string
}

function SaveAsCRTypeModal({ fsi, onClose }: SaveAsCRTypeModalProps) {
  const context = useServiceContext()
  const { t: translate } = useTranslation()
  const [isOpen, setIsOpen] = useState(true)
  const formData: FormValues = { name: '', description: '' }

  const doClose = () => {
    setIsOpen(false)
    if (onClose) {
      onClose()
    }
  }

  function doSave(values: FormValues) {
    const cloneVals = values?.description?.trim() === '' ? _.omit(cloneDeep(values), 'description') : cloneDeep(values)
    changeRequestTypesService.saveAsCRType(fsi?.id as string | number, cloneVals).then(
      () => {
        toast.success(translate('WF_TEMPLATES_CREATE_SUCCESS_MSG'))
        doClose()
      },
      (data) => {
        toast.error(translate('CHANGE_REQUEST_TYPES_CREATE_FAIL_MSG', { error: data.data.message }))
      }
    )
  }

  return (
    <Modal show={isOpen} title={translate('MANAGE_WF_SAVE_AS_WF_TEMPLATE_TITLE')} handleClose={doClose}>
      <Formik
        innerRef={(el) => {
          el ? (context.store.formRef = el) : null
        }}
        initialValues={{
          ...cloneDeep(formData)
        }}
        enableReinitialize
        validate={(values: FormValues) => {
          const errors: Partial<Record<keyof FormValues, string>> = {}
          values?.name?.trim() === '' ? (errors.name = Validation.general.mixed.required) : null
          return errors
        }}
        onSubmit={(values) => {
          doSave(values)
        }}
      >
        {({ handleSubmit, setFieldValue }) => (
          <>
            <Modal.Body>
              <div className="form-group md-form-group w100p">
                <label>{fsi?.type === FsiType.FOLDER ? translate('FSI_TYPE_FOLDER') : translate('DOCUMENT')}</label>
                {fsi?.name ? <p className="whitespaceprewrap fs12">{fsi.name}</p> : null}
              </div>
              <FormGroup controlId="k3ecf1a6-d9c4-693b-884e-n8480215dbff" style={{ maxWidth: '2rem' }}>
                <Form.Label>{translate('NAME')}</Form.Label>
                <Field
                  type="text"
                  style={{ width: '30rem' }}
                  name="name"
                  maxLength="255"
                  className="md-input"
                  id="in-fulltext"
                  autoFocus
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('name', event.target.value)
                  }}
                />
                <ErrorMessageStyled name={'name'} />
              </FormGroup>
              <FormGroup style={{ marginTop: '2rem' }} controlId="n3ecf1a6-d9c4-783b-884e-l8480215dbdf">
                <Form.Label style={{ display: 'block' }}>{translate('DESCRIPTION')}</Form.Label>
                <Field
                  type="text"
                  name="description"
                  style={{ width: '30rem' }}
                  maxLength="255"
                  className="md-input"
                  id="in-fulltext"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('description', event.target.value)
                  }}
                />
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button className="btn btn-close" variant="link" type="button" onClick={doClose}>
                {translate('CANCEL')}
              </Button>
              <Button type="submit" className="btn btn-primary at_btnSaveApprovers" onClick={() => handleSubmit()}>
                {translate('SAVE_BTN')}
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default SaveAsCRTypeModal
